import {
  BarChartOutlined,
  BranchesOutlined,
  DatabaseOutlined,
  FileTextOutlined,
  FolderOpenOutlined,
  FundProjectionScreenOutlined,
  GlobalOutlined,
  ApiOutlined,
  RobotOutlined,
  SettingOutlined,
  SlidersOutlined,
  SwapOutlined,
  TableOutlined,
  ThunderboltOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/menu.css";

function openKeysForPath(pathname) {
  const keys = [];
  if (pathname.startsWith("/compare")) keys.push("compare");

  if (
    pathname.startsWith("/libraries") ||
    pathname.startsWith("/features/rulebuilder")
  )
    keys.push("library");

  // Automation — include ui-automation
  if (
    pathname.startsWith("/mastersuite") ||
    pathname.startsWith("/ui-automation")
  )
    keys.push("automation");

  if (pathname.startsWith("/ai")) keys.push("ai");
  return keys;
}

function MenuComponent() {
  const navigate = useNavigate();
  const location = useLocation();
  const [openKeys, setOpenKeys] = useState(() =>
    openKeysForPath(window.location.pathname),
  );

  useEffect(() => {
    setOpenKeys((prev) =>
      Array.from(new Set([...prev, ...openKeysForPath(location.pathname)])),
    );
  }, [location.pathname]);

  const selectedKeys = useMemo(() => {
    const p = location.pathname;
    if (p === "/") return ["/dashboard"];
    if (p.startsWith("/results")) return ["/results"];
    if (p.startsWith("/compare")) return ["/compare"];
    if (p.startsWith("/ui-automation")) return ["/ui-automation"];
    if (p.startsWith("/mastersuite")) return ["/mastersuite"];
    if (p.startsWith("/gateway")) return ["/gateway"];
    if (
      p.startsWith("/admin") ||
      p.startsWith("/environments") ||
      p === "/jobs"
    )
      return ["/admin"];
    return [p];
  }, [location.pathname]);

  const menu = [
    {
      label: "Dashboard",
      key: "/dashboard",
      icon: <BarChartOutlined />,
    },

    // ─── Library ─────────────────────────────────────────────
    {
      label: "Library",
      key: "library",
      icon: <FolderOpenOutlined />,
      children: [
        {
          label: "Control Documents",
          key: "/libraries/filespec",
          icon: <FileTextOutlined />,
        },
        {
          label: "Test Suites",
          key: "/libraries/suites",
          icon: <TableOutlined />,
        },
        {
          label: "Rule Builder",
          key: "/features/rulebuilder",
          icon: <SlidersOutlined />,
        },
        {
          label: "Task Library",
          key: "/libraries/task",
          icon: <UnorderedListOutlined />,
        },
      ],
    },

    // ─── Reconciliation (route key stays /compare) ───────────
    {
      label: "Reconciliation",
      key: "/compare",
      icon: <SwapOutlined />,
    },

    // ─── Automation ──────────────────────────────────────────
    {
      label: "Automation",
      key: "automation",
      icon: <ThunderboltOutlined />,
      children: [
        {
          label: "Workflow",
          key: "/mastersuite",
          icon: <BranchesOutlined />,
        },
        {
          label: "App Automation",
          key: "/ui-automation",
          icon: <GlobalOutlined />,
        },
      ],
    },

    // ─── AI Features (placeholder) ───────────────────────────
    {
      label: "AI Features",
      key: "ai",
      icon: <RobotOutlined />,
      children: [
        {
          label: "BRD Generator",
          key: "/ai/brd",
          icon: <FileTextOutlined />,
          disabled: true,
        },
        {
          label: "RTM & Test Cases",
          key: "/ai/rtm",
          icon: <TableOutlined />,
          disabled: true,
        },
        {
          label: "SQL Builder",
          key: "/ai/sql",
          icon: <DatabaseOutlined />,
          disabled: true,
        },
      ],
    },

    // ─── Gateway ─────────────────────────────────────────────
    {
      label: "Gateway",
      key: "/gateway",
      icon: <ApiOutlined />,
    },

    // ─── Results ─────────────────────────────────────────────
    {
      label: "Results",
      key: "/results",
      icon: <FundProjectionScreenOutlined />,
    },

    // ─── Admin (card hub) ────────────────────────────────────
    {
      label: "Admin",
      key: "/admin",
      icon: <SettingOutlined />,
    },
  ];

  const onClick = ({ key }) => {
    if (key.startsWith("/") && !key.startsWith("/ai")) {
      navigate(key);
    }
  };

  return (
    <div className="sidebar-menu-scroll">
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={selectedKeys}
        openKeys={openKeys}
        onOpenChange={setOpenKeys}
        style={{
          textAlign: "left",
          paddingTop: "8px",
          border: "none",
          background: "var(--arc-primary)",
        }}
        items={menu}
        onClick={onClick}
      />
    </div>
  );
}

export default MenuComponent;
